import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "tab"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_ContactTile = _resolveComponent("ContactTile")
  const _component_CompanyTile = _resolveComponent("CompanyTile")
  const _component_TopicTile = _resolveComponent("TopicTile")
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_EditPerson = _resolveComponent("EditPerson")
  const _component_EditCompany = _resolveComponent("EditCompany")
  const _component_EditTopic = _resolveComponent("EditTopic")
  const _component_SignalSections = _resolveComponent("SignalSections")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["signal", {'has-tracker': $options.has_tracker}])
  }, [
    ($options.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          class: "loader"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          ($options.persona_type)
            ? (_openBlock(), _createBlock(_component_ContactTile, {
                key: 0,
                name: $data.item.entity_name,
                avatar: $data.item.entity_logo_url,
                position: $data.contact?.position,
                company: {name: $data.item.parent_entity_name, logo_url: $data.item.parent_entity_logo_url}
              }, null, 8 /* PROPS */, ["name", "avatar", "position", "company"]))
            : ($options.company_type)
              ? (_openBlock(), _createBlock(_component_CompanyTile, {
                  key: 1,
                  class: "header",
                  name: $data.item.entity_name,
                  logo: $data.item.entity_logo_url,
                  type: $data.item.type
                }, null, 8 /* PROPS */, ["name", "logo", "type"]))
              : ($options.topic_type)
                ? (_openBlock(), _createBlock(_component_TopicTile, {
                    key: 2,
                    class: "header",
                    name: $data.item.entity_name
                  }, null, 8 /* PROPS */, ["name"]))
                : _createCommentVNode("v-if", true),
          _createVNode(_component_Tabs, {
            modelValue: $data.active_tab,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.active_tab) = $event)),
            class: "tabs",
            tabs: $options.anchors,
            bordered: "",
            onTabClick: $options.onTabClick
          }, null, 8 /* PROPS */, ["modelValue", "tabs", "onTabClick"]),
          ($options.tracker)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                ($options.persona_type)
                  ? (_openBlock(), _createBlock(_component_EditPerson, {
                      key: 0,
                      class: "tab tracker",
                      "contact-id": $data.item.user_entity_id
                    }, null, 8 /* PROPS */, ["contact-id"]))
                  : ($options.company_type)
                    ? (_openBlock(), _createBlock(_component_EditCompany, {
                        key: 1,
                        class: "tab tracker",
                        "company-id": $data.item.user_entity_id
                      }, null, 8 /* PROPS */, ["company-id"]))
                    : ($options.topic_type)
                      ? (_openBlock(), _createBlock(_component_EditTopic, {
                          key: 2,
                          class: "tab tracker",
                          "topic-id": $data.item.user_entity_id
                        }, null, 8 /* PROPS */, ["topic-id"]))
                      : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createBlock(_component_SignalSections, {
                key: 4,
                ref: "sections",
                class: "tab",
                tab: $data.active_tab,
                item: $data.item,
                onAnchorChanged: _cache[1] || (_cache[1] = $event => ($data.active_tab = $event))
              }, null, 8 /* PROPS */, ["tab", "item"]))
        ]))
  ], 2 /* CLASS */))
}